<template>
  <project-base :state="state">
    <div class="container mt-12">
      <content-section>
        <template #title>
          <h2>Change Request</h2>
          <div
            class="italic text-sm text-grey-700"
          >
            <p>As you are the lead for your company you are entitled to make requests to the certain aspects of the project. Please select your request from the drop-down and fill out the form.</p>
          </div>
        </template>
        <request-form
          v-if="canEdit"
          :can-request="canEdit"
          :requests="state.change_request_options"
          :staff="state.staff"
          @request:log="addLogEntry"
        />
        <template #cardless>
          <div class="p-6">
            <h2 class="text-base flex">
              <icon
                icon="chat-group-alt"
                class="w-6 h-6 icons-primary mr-2"
              />
              Request log
            </h2>
            <log-listing
              :completed="competition.statuses.completed"
              :log="requestLog"
            />
          </div>
        </template>
      </content-section>
    </div>
  </project-base>
</template>

<script>
import { userProjectMixin } from '../../mixins/userProject.js'
export default {
  name: 'ProjectViewRequestsIndex',
  mixins: [userProjectMixin],
  data() {
    return {
      requestLog: []
    }
  },
	created() {
    document.title = `Project ${ this.state.project.ref } Change Requests :: ${document.title}`;
    window._project = this.project.uuid;
    this.requestLog = this.state.log;
	},
  methods: {
    addLogEntry(entry) {
      entry.type = 'change_request'
      return this.requestLog = [entry, ...this.requestLog]
    }
  },
}
</script>
